import { __assign } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import StyledComponent from "./Styled";
/**
 * moaui Styled Icon (Single)
 *
 * @param props - iconName, opacity, toButton, onClick
 * @example
 * <Icon
 * 	iconName="Apple"
 * 	opacity={1}
 * 	toButton={false}
 * />
 * @returns React.ReactElement
 */
var Icon = function (props) { return (_jsx(StyledComponent, __assign({}, props))); };
Icon.defaultProps = {
    iconName: "Add",
    opacity: 1,
};
var SampleProps = {
    id: '',
    iconName: "Apple",
    opacity: 1,
    toButton: false,
};
export default Icon;
export { SampleProps as IconSample, };
